"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearLocationMarker = exports.animateLocationMarker = exports.updateNonBookableMarkers = void 0;
/**
 * @param {maplibregl.Marker[]} markers
 * @param {Array} locations
 */
const updateNonBookableMarkers = (markers, locations) => {
    const nonBookableIds = new Set(locations.map((loc) => loc.id));
    if (nonBookableIds.size) {
        markers.forEach(({ marker, meta }) => {
            if (nonBookableIds.has(meta.location.id)) {
                marker.addClassName('nonbookable');
            }
        });
    }
};
exports.updateNonBookableMarkers = updateNonBookableMarkers;
// https://healthsparq.atlassian.net/browse/KENG-41045
const animateLocationMarker = () => { };
exports.animateLocationMarker = animateLocationMarker;
const clearLocationMarker = () => { };
exports.clearLocationMarker = clearLocationMarker;
//# sourceMappingURL=ProviderLocations.aws.utils.js.map